import { z } from 'zod';
import { PAIN_SCALE_VALUES } from '@/components/ui/pain-scale';
import { templateAdvanceLogicV1Schema } from './advance-logic';
import { templateBaseSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import { templateReferenceV1Schema } from './reference';

export const templatePainScaleSchema = templateBaseSchema.extend({
  type: z.literal('painScale'),
  name: z.string(),
  isRequired: z.boolean(),
  value: z.enum(PAIN_SCALE_VALUES).or(z.literal('')),
  advanceLogics: templateAdvanceLogicV1Schema,
  reference: templateReferenceV1Schema,
  ...fieldLayoutShape,
});

export type TemplatePainScaleV1 = z.infer<typeof templatePainScaleSchema>;
